/* prettier-ignore */

const data = {
  common: {
    title: "Piggy Valut",
    description: "Piggy Valut 管理システム",
    buttons: {
      search: "搜索",
      login: "登录",
      register: "注册",
      approve: "批准",
      reject: "拒绝",
      refresh: "刷新",
      viewDetails: "查看详情",
      back: "返回",
      save: "保存",
      saving: "保存中...",
      cancel: "取消",
      confirm: "确认",
      delete: "删除",
      deleting: "删除中...",
      hide: "隐藏",
      show: "显示",
      close: "关闭",
    },
    placeholders: {
      search: "搜索...",
    },
    messages: {
      success: "成功",
      updateSuccess: "用户信息更新成功",
      loginSuccess: "登录成功",
      logoutSuccess: "退出登录成功",
      registerSuccess: "注册成功",
      criticalError: "致命错误",
      forbidden: "禁止请求",
      notAuthorized: "未授权",
      noData: "没有数据",
      tooManyRequests: "请稍后再试。你发送的请求太频繁了。",
      blocked: "用户已被封禁",
      pending: "用户待审核",
      ipBlocked: "IP已被封禁",
      serverError: "服务器错误",
      invalidInput: "输入无效",
      invalidCredentials: "用户名或密码错误",
      invalidReferrer: "推荐人不存在",
      referrerRequired: "需要推荐人",
      ipBlockedFailed: "IP封禁失败",
      notAllowedPartner: "不允许的合作伙伴",
      invalidPassword: "验证密码失败",
      databaseError: "数据库错误",
      usernameInUse: "用户名已存在",
      createUserError: "创建用户失败",
      failedFetch: "数据获取失败",
      failedFetchUser: "用户获取失败",
      failedFetchPendingUsers: "待审核用户获取失败",
      failedFetchOnlineUsers: "在线用户获取失败",
      failedFetchUserTree: "用户树获取失败",
      failedFetchUsers: "无法获取用户。",
      failedFetchUserUpline: "用户上级获取失败",
      failedFetchUserDownline: "用户下级获取失败",
      failedUpdate: "数据更新失败",
      failedUpdateUser: "用户更新失败",
      failedSave: "数据保存失败",
      vendorError: "供应商错误",
      confirmDelete: "确定删除吗？",
      deleteSuccess: "用户已删除",
      tokenRefreshed: "令牌已刷新",
      tokenRefreshFailed: "令牌刷新失败",
      invalidIpAddress: "IP地址无效",
      invalidChipTransactionReason: "彩金交易理由无效",
      captchaExpired: "验证码已过期",
      captchaInvalid: "验证码无效",
      insufficientChip: "筹码不足",
      insufficientPoint: "积分不足",
      failedCollectChips: "筹码收集失败",
      failedGiveChips: "筹码发放失败",
      failedPointsToChips: "点数转换为筹码失败",
      notFoundHeadquarter: "总部不存在",
      notFoundUser: "用户不存在",
      failedFetchAdmin: "管理员获取失败",
      failedFetchHeadquarter: "总部获取失败",
      adminNotAllowed: "管理员不允许访问",
      partnerNotAllowed: "合作伙伴不允许访问",
      userNotAllowed: "用户不允许访问",
      failedFetchTotalInquiries: "查询总数获取失败",
      failedFetchInquiries: "查询列表获取失败",
      failedCreateInquiry: "查询创建失败",
      failedUpdateInquiry: "查询更新失败",
      failedFetchInquiry: "查询获取失败",
      failedFetchTotalNotices: "公告总数获取失败",
      failedFetchNotices: "公告列表获取失败",
      failedCreateNotice: "公告创建失败",
      failedUpdateNotice: "公告更新失败",
      failedIncrementNoticeViewCount: "公告浏览量增加失败",
      failedFetchNotice: "公告获取失败",
      failedFetchBankingHistory: "银行交易历史获取失败",
      failedFetchTotalBankingHistory: "银行交易历史总数获取失败",
      failedFetchDownlineBankingHistory: "下线银行交易历史获取失败",
      failedFetchDownlineTotalBankingHistory: "下线银行交易历史总数获取失败",
      failedAddBankingHistory: "银行交易历史添加失败",
      failedUpdateBankingHistoryStatus: "更新银行交易历史状态失败",
      failedFetchChipTransactionHistory: "筹码交易历史获取失败",
      failedFetchTotalChipTransactionHistory: "筹码交易历史总数获取失败",
      failedFetchDownlineChipTransactionHistory: "下线筹码交易历史获取失败",
      failedFetchDownlineTotalChipTransactionHistory: "下线筹码交易历史总数获取失败",
      failedAddChipTransactionHistory: "筹码交易历史添加失败",
      failedFetchGameBetHistoryByCallbackId: "通过回调ID获取游戏投注历史失败",
      failedFetchGameBetHistory: "游戏投注历史获取失败",
      failedFetchTotalGameBetHistory: "游戏投注历史总数获取失败",
      failedFetchDownlineGameBetHistory: "下线游戏投注历史获取失败",
      failedFetchDownlineTotalGameBetHistory: "下线游戏投注历史总数获取失败",
      failedAddGameBetHistory: "游戏投注历史添加失败",
      failedFetchChipChangeHistory: "筹码变更历史获取失败",
      failedFetchTotalChipChangeHistory: "筹码变更历史总数获取失败",
      failedAddChipChangeHistory: "筹码变更历史添加失败",
      failedFetchGameCallbackHistory: "游戏回调历史获取失败",
      failedFetchTotalGameCallbackHistory: "游戏回调历史总数获取失败",
      failedAddGameCallbackHistory: "游戏回调历史添加失败",
      failedUpdateGameCallbackHistory: "游戏回调历史更新失败",
      failedDeleteGameCallbackHistory: "游戏回调历史删除失败",
      failedFetchGamePlayHistory: "游戏记录获取失败",
      failedFetchTotalGamePlayHistory: "游戏记录总数获取失败",
      failedAddGamePlayHistory: "游戏记录添加失败",
      failedFetchLoginHistory: "登录历史获取失败",
      failedFetchTotalLoginHistory: "登录历史总数获取失败",
      failedAddLoginHistory: "登录历史添加失败",
      failedFetchPointChangeHistory: "积分变更历史获取失败",
      failedFetchTotalPointChangeHistory: "积分变更历史总数获取失败",
      failedAddPointChangeHistory: "积分变更历史添加失败",
      failedFetchSettings: "设置列表获取失败",
      failedFetchSettingByKey: "通过键获取设置失败",
      failedCreateSetting: "设置创建失败",
      noFieldsToUpdateSetting: "没有要更新的字段",
      settingNotFound: "未找到设置",
      failedUpdateSetting: "设置更新失败",
      failedDeleteSetting: "设置删除失败",
      failedUpdateMultipleSettings: "多个设置更新失败",
      failedFetchUserDownlineTotalFinance: "获取下线总财务信息失败",
      failedFetchUserDownlineSettlement: "获取下线结算信息失败",
      failedFetchMyTotalAddedChips: "获取我的总增加筹码失败",
      failedFetchMyTotalSubtractedChips: "获取我的总扣除筹码失败",
      failedFetchMyMoneyChanges: "获取我的资金变动失败",
      failedFetchTodaysNewUsers: "获取今日新用户数失败",
      failedFetchTodayStats: "获取今日统计失败",
      failedFetchTotalPendingUsers: "获取总待处理用户数失败",
      failedFetchTotalOnlineUsers: "获取总在线用户数失败",
      failedFetchTotalPendingInquiries: "获取总待处理咨询数失败",
      failedFetchTotalDepositAndWithdraw: "获取总存取款信息失败",
      failedFetchMonitoringStats: "获取监控统计失败",
      failedUpdateUserFinance: "更新用户财务信息失败",
      failedAddUserChip: "添加用户筹码失败",
      failedAddUserPoint: "添加用户积分失败",
      failedSubtractUserChip: "扣除用户筹码失败",
      failedCollectSubUserChips: "回收下级用户筹码失败",
      failedGiveChipsToSubUser: "向下级用户发放筹码失败",
      failedUpdateUserStatus: "更新用户状态失败",
      failedUpdateUserRole: "更新用户角色失败",
      failedUpdateUserOnlineStatus: "更新用户在线状态失败",
      failedUpdateGameVendorForDownline: "更新下级游戏供应商失败",
      failedCreateUsers: "创建多个用户失败",
      failedFetchUserById: "通过ID获取用户失败",
      failedFetchUserByVendorId: "通过供应商ID获取用户失败",
      failedFetchUserFinance: "获取用户财务信息失败",
      failedFetchUserRowsByRole: "通过角色获取用户失败",
      failedFetchAdminId: "获取管理员ID失败",
      failedFetchHeadquarterId: "获取总部ID失败",
      failedFetchUsersByReferrer: "通过推荐人获取用户失败",
      failedFetchUsersWithoutReferrer: "通过推荐人获取用户失败",
      failedFetchPendingUsersTotal: "获取总待处理用户数失败",
      failedFetchOnlineUsersTotal: "获取总在线用户数失败",
      failedFetchUserDetail: "获取用户详情失败",
      userNotFound: "用户不存在",
      failedFetchVendorHistory: "获取供应商历史失败",
      failedAddVendorHistory: "添加供应商历史失败",
      failedUpdateVendorHistory: "更新供应商历史失败",
      referrerNotFound: "推荐人不存在",
      failedToGetAdminId: "获取管理员ID失败",
      failedToGetHeadquarterId: "获取总部ID失败",
      failedToGetUserDetail: "获取用户详情失败",
      failedToGetUserFinance: "获取用户财务信息失败",
      failedFetchUserByRole: "按角色获取用户失败",
      failedAddBetAmount: "添加投注金额失败",
      invalidReason: "原因无效",
      refreshTokenRequired: "需要刷新令牌",
    },
    pagination: {
      previous: "上一页",
      next: "下一页",
      page: "页",
    },
    roles: {
      admin: "管理员",
      headquarter: "总部",
      headquarter_branch: "支社",
      branch: "分部",
      distributor: "代理",
      store: "店铺",
      user: "用户",
    },
    appBar: {
      search: {
        placeholder: "搜索...",
      },
      userProfile: "个人资料",
      userSettings: "设置",
      darkMode: "深色模式",
      lightMode: "浅色模式",
      logout: "退出登录",
    },
    loading: {
      loading: "加载中...",
      error: "发生错误: ",
    },
    search: {
      placeholder: "请输入搜索关键词",
      button: "搜索",
      datePlaceholder: "选择日期",
    },
    userTree: {
      title: "组织图",
    },
    status: {
      pending: "待处理",
      approved: "已批准",
      rejected: "已拒绝",
      canceled: "已取消",
    },
    gameVendorSelect: {
      officialLabel: "官方游戏供应商",
      unofficialLabel: "非官方游戏供应商",
      officialPlaceholder: "选择官方游戏供应商",
      unofficialPlaceholder: "选择非官方游戏供应商",
      save: "保存",
      none: "无",
    },
    dateRangeSelector: {
      startDatePlaceholder: "开始日期",
      endDatePlaceholder: "结束日期",
      selectPlaceholder: "选择日期范围",
      periods: {
        day: "今天",
        week: "1周",
        twoWeeks: "2周",
        month: "1个月",
        threeMonths: "3个月",
        sixMonths: "6个月",
        year: "1年",
        custom: "自定义",
      },
    },
  },
  auth: {
    login: "登录",
    register: "注册",
    loginDescription: "请输入用户名和密码登录",
    registerDescription: "创建新账户",
    email: "电子邮箱",
    password: "密码",
    username: "用户名",
    referrer: "推荐人",
    referrerPlaceholder: "请输入推荐人用户名",
    confirmPassword: "确认密码",
    loginButton: "登录",
    registerButton: "注册",
    captcha: "安全问题",
    captchaPlaceholder: "请输入答案",
    loginProcessing: "登录中...",
    registerProcessing: "处理中...",
    hasAccount: "已有账户？",
    noAccount: "没有账户？",
    goToLogin: "去登录",
    goToRegister: "去注册",
    minLengthUsername: "用户名至少需要3个字符",
    minLengthPassword: "密码至少需要8个字符",
    invalidCaptcha: "安全问题答案错误",
    passwordMismatch: "密码不匹配",
    loginSuccess: "登录成功",
    registerSuccess: "注册成功",
    refresh: "刷新",
  },
  sidebar: {
    systemManagement: "系统/公告",
    partnerManagement: "合作伙伴管理",
    userManagement: "用户管理",
    bankingManagement: "充值/提现管理",
    bettingStatus: "投注/流水状态",
    apiDocs: "API文档",
    settings: "设置",
  },
  statsOverview: {
    balance: "保有金",
    pendingApproval: "待审核",
    depositRequest: "充值请求",
    withdrawRequest: "提现请求",
    inquiry: "1:1 咨询",
    currentUsers: "当前用户",
    cases: "件",
    users: "人",
    userBalance: "用户筹码余额",
    userPoint: "用户积分余额",
    partnerBalance: "合作伙伴筹码余额",
    partnerPoint: "合作伙伴积分余额",
  },
  dashboard: {
    title: "仪表板",
    desc: "管理员仪表板",
    registeredUsers: "注册用户",
    activeUsers: "活跃用户",
    systemStatus: "系统状态",
    systemNormal: "正常",
    allSystemsOperational: "所有系统运行正常",
    topStats: {
      chip: {
        title: "筹码余额",
        vendorBalance: "供应商 筹码余额",
      },
      point: {
        title: "持有点数",
        convertButton: "转换为筹码",
      },
      user: {
        title: "用户",
        listButton: "所属用户列表",
      },
    },
    moneyStatus: {
      userBalance: "用户 筹码余额",
      userPoint: "用户 点数余额",
      partnerBalance: "合作伙伴 筹码余额",
      partnerPoint: "合作伙伴 点数余额",
    },
    transactionSummary: {
      deposit: "充值",
      withdraw: "提现",
      chipGive: "彩金发放",
      chipCollect: "彩金回收",
      newUsers: "今日新用户",
      profit: "今日投注利润",
      profitDesc: "(投注 - 中奖 - 流水)",
    },
    transactionDetails: {
      title: "保有金 = 筹码 + 流水, 充值/提现是给所属用户的充值/提现的合计",
      search: "搜索",
      prevBalance: "上次持有金额",
      deposit: "充值",
      withdraw: "提现",
      currentBalance: "当前持有金额",
      bettingWinning: "投注 / 中奖",
      rolling: "流水金额",
      userBalanceLabel: "用户持有余额",
      partnerBalanceLabel: "合作伙伴持有余额",
      depositLabel: "充值",
      chipGiveLabel: "彩金发放",
      totalLabel: "Total",
      withdrawLabel: "提现",
      chipCollectLabel: "彩金回收",
      bettingLabel: "投注金额",
      winningLabel: "中奖金额",
      bettingResultLabel: "投注 - 中奖",
      totalRollingLabel: "总流水金额",
      actualRollingLabel: "实际流水金额",
    },
    transactionHistory: {
      title: "资金变动记录",
      search: "搜索",
      increase: {
        title: "余额增加",
        headDeposit: "公司充值",
        upperChipGive: "上部彩金发放",
        lowerChipCollect: "下部彩金回收",
        rollingConvert: "流水转换",
        total: "增加总计",
      },
      decrease: {
        title: "余额减少",
        headWithdraw: "公司提现",
        upperChipCollect: "上部彩金回收",
        lowerChipGive: "下部彩金发放",
        total: "减少总计",
      },
    },
    notice: {
      title: "公告",
      columns: {
        id: "#",
        title: "标题",
        createdAt: "创建时间",
      },
    },
  },
  users: {
    list: {
      title: "用户列表",
      desc: "管理注册用户",
      columns: {
        username: "用户ID",
        details: "详情",
        banking: "充值/提现",
        chip: "彩金余额",
        point: "积分余额",
        affiliation: "所属",
        depositWithdraw: "充值/提现",
        slotStats: "(老虎机)/投注/中奖/流水",
        casinoStats: "(真人)/投注/中奖/流水",
        sportsStats: "(体育)/投注/中奖/流水",
      },
      filters: {
        byUsername: "按用户ID",
        byChip: "按筹码余额",
        byLatest: "按最新注册",
        byOldest: "按最早注册",
      },
    },
    pending: {
      title: "待审核用户",
      desc: "管理待审核用户",
      columns: {
        username: "用户ID",
        details: "详情",
        status: "状态",
        headquarter: "总部",
        branch: "分部",
        distributor: "代理",
        store: "店铺",
        createdAt: "创建时间",
        contact: "联系电话",
        actions: "批准",
      },
      approve: "批准",
      reject: "拒绝",
      pendingStatus: "待审核",
      viewDetails: "查看详情",
    },
    online: {
      title: "在线用户",
      desc: "管理在线用户",
      columns: {
        username: "用户ID",
        details: "详情",
        accountHolder: "账户持有人",
        affiliation: "所属",
        banking: "充值/提现",
        chip: "彩金余额",
        depositWithdraw: "总充值/总提现",
        slotStats: "(老虎机)/投注/中奖/流水",
        casinoStats: "(真人)/投注/中奖/流水",
        sportsStats: "(体育)/投注/中奖/流水",
        lastPlayedGame: "最近游戏",
      },
      noLastGame: "无记录",
    },
    chip: {
      giveTitle: "彩金发放",
      collectTitle: "彩金回收",
      giftTitle: "彩金赠送",
      giveChip: "发放彩金",
      collectChip: "回收彩金",
      giftChip: "赠送彩金",
      description: "输入金额和理由，然后点击确认按钮。",
      amount: "金额",
      memo: "备注",
      memoPlaceholder: "请输入备注",
      errors: {
        invalidAmount: "请输入有效金额",
        actionFailed: "操作失败",
      },
    },
    status: {
      active: "活跃",
      pending: "待处理",
      rejected: "已拒绝",
      block: "已封禁",
      online: "在线",
      offline: "离线",
    },
    detail: {
      title: "用户详情",
      desc: "管理用户详情",
      tabs: {
        userInfo: "会员信息",
        loginHistory: "登录记录",
        messages: "消息",
        chipChangeHistory: "点数变动记录",
        rechargeHistory: "充值记录",
        exchangeHistory: "兑换记录",
        chipReceivedHistory: "彩金领取记录",
        chipSentHistory: "彩金发放记录",
        gamePlayHistory: "游戏执行记录",
        gameBetHistory: "游戏投注记录",
        restrictedGameBetting: "限制游戏投注记录",
        pragmatic: "Pragmatic",
        userLogs: "用户日志记录",
      },
      userSummary: {
        role: "形态",
        username: "用户名",
        chip: "彩金余额",
        point: "持有点数",
      },
      userInfo: {
        title: "用户详情",
        basicInfo: "基本信息",
        moneyInfo: "财务信息",
        gameInfo: "游戏信息",
        bankInfo: "银行信息",
        number: "编号",
        password: "密码",
        username: "用户名",
        contact: "联系电话",
        status: "状态",
        gameVendor: "游戏供应商",
        gameVendorPlaceholder: "选择游戏供应商",
        chip: "筹码",
        point: "积分",
        totalDeposit: "总存款",
        totalWithdraw: "总提款",
        slotBet: "老虎机投注",
        slotWin: "老虎机赢利",
        casinoBet: "真人投注",
        casinoWin: "真人赢利",
        sportsBet: "体育投注",
        sportsWin: "体育赢利",
        casinoBetLimit: "真人投注限制",
        casinoWinLimit: "真人赢利限制",
        bankName: "银行名称",
        bankAccount: "银行账号",
        bankAccountHolder: "开户人",
        memo: "备注",
        memoPlaceholder: "请输入备注",
        createdAt: "注册时间",
        lastLogin: "最近登录",
        blockRejectReason: "封禁/拒绝原因",
        blockRejectReasonPlaceholder: "请输入封禁或拒绝原因",
      },
      loginHistory: {
        title: "登录记录",
        columns: {
          ipAddr: "访问IP",
          isSuccess: "成功状态",
          createdAt: "访问时间",
          actions: "操作",
          blockIP: "封禁IP",
        },
      },
      chipChangeHistory: {
        title: "点数变动记录",
        columns: {
          amountBefore: "变动前",
          amountAfter: "变动后",
          amountDiff: "增减",
          sender: "发送方",
          receiver: "接收方",
          reason: "理由",
          referenceValue: "参考值",
          rollingBefore: "流水(前)",
          rollingAfter: "流水(后)",
          createdAt: "变动时间",
        },
      },
      rechargeHistory: {
        title: "充值记录",
        columns: {
          amountBefore: "充值前",
          amountAfter: "充值后",
          requestAmount: "请求金额",
          bankInfo: "银行信息",
          status: "状态",
          requestedAt: "请求时间",
          processedAt: "处理时间",
          memo: "备注",
        },
      },
      exchangeHistory: {
        title: "兑换记录",
        columns: {
          amountBefore: "兑换前",
          amountAfter: "兑换后",
          requestAmount: "请求金额",
          bankInfo: "银行信息",
          status: "状态",
          requestedAt: "请求时间",
          processedAt: "处理时间",
          memo: "备注",
        },
      },
      chipReceiveHistory: {
        title: "彩金领取记录",
        columns: {
          receiverId: "领取者ID",
          receiverUsername: "领取者用户名",
          receiverRole: "领取者形态",
          amount: "彩金金额",
          reason: "理由",
          memo: "备注",
          createdAt: "注册时间",
        },
      },
      chipSendHistory: {
        title: "彩金发放记录",
        columns: {
          senderId: "发放者ID",
          senderUsername: "发放者用户名",
          senderRole: "发放者形态",
          amount: "彩金金额",
          reason: "理由",
          memo: "备注",
          createdAt: "注册时间",
        },
      },
      gamePlayHistory: {
        title: "游戏执行记录",
        columns: {
          supplier: "游戏提供商",
          gameName: "游戏名称",
          executionTime: "执行时间",
        },
      },
      gameBetHistory: {
        title: "游戏投注记录",
        columns: {
          supplier: "游戏提供商",
          gameName: "游戏名称",
          roundId: "回合ID",
          type: "类型",
          betAmount: "投注金额",
          winAmount: "中奖金额",
          balance: "余额",
          betTime: "投注时间",
          details: "详情",
        },
      },
    },
    creation: {
      title: "用户创建",
      desc: "创建新的 {0}",
      username: "用户名",
      usernamePlaceholder: "输入用户名",
      password: "密码",
      passwordPlaceholder: "输入密码",
      count: "数量",
      countPlaceholder: "输入数量",
      contact: "联系电话",
      contactPlaceholder: "请输入联系电话",
      bank: "银行",
      bankSelect: "=== 选择 ===",
      bankKookmin: "国民",
      bankShinhan: "新韩",
      bankWoori: "友利",
      bankNonghyup: "农协",
      bankHana: "韩亚",
      accountNumber: "银行账号",
      accountNumberPlaceholder: "请输入银行账号",
      accountHolder: "开户人",
      accountHolderPlaceholder: "请输入开户人",
      errors: {
        requiredFields: "输入用户名和密码",
        invalidCount: "数量必须大于0",
      },
      rollingRateSlot: "滚动手续费率(老虎机)",
      losingRateSlot: "亏损手续费率(老虎机)",
      rollingRateCasino: "滚动手续费率(娱乐场)",
      losingRateCasino: "亏损手续费率(娱乐场)",
      rollingRateSports: "滚动手续费率(体育)",
      losingRateSports: "亏损手续费率(体育)",
    },
  },
  partners: {
    common: {
      add: "合作伙伴注册",
    },
    list: {
      all: {
        title: "合作伙伴列表",
        desc: "管理注册合作伙伴",
      },
      head: {
        title: "总部列表",
        desc: "管理注册总部",
      },
      branch: {
        title: "分部列表",
        desc: "管理注册分部",
      },
      headBranch: {
        title: "总部支社列表",
        desc: "管理注册总部支社",
      },
      distributor: {
        title: "代理列表",
        desc: "管理注册代理",
      },
      store: {
        title: "店铺列表",
        desc: "管理注册店铺",
      },
      search: {
        placeholder: "输入合作伙伴用户名",
      },
      columns: {
        username: "用户ID",
        details: "详情",
        role: "形态",
        banking: "充值/提现",
        chip: "彩金余额",
        point: "积分余额",
        depositWithdraw: "充提",
        rollingPercentage: {
          slot: "流水 % (老虎机)",
          casino: "流水 % (真人)",
          sports: "流水 % (体育)",
        },
        losingPercentage: {
          slot: "亏损 % (老虎机)",
          casino: "亏损 % (真人)",
          sports: "亏损 % (体育)",
        },
        createdAt: "注册时间",
        hqTransactions: "总部充提",
        chipTransactions: "彩金发放/回收",
        betting: {
          casino: "投注(真人)",
          slot: "投注(老虎机)",
          sports: "投注(体育)",
        },
        downlineManagement: "下级管理",
        createDownline: "下级注册",
      },
      statsCard: {
        basicInfo: {
          title: "基本信息",
          type: "类型",
          username: "用户名",
          chipAndPointBalance: "筹码 / 积分",
          contact: "联系电话",
          bankName: "银行名称",
          bankAccount: "银行账号",
          accountHolder: "开户人",
        },
        rollingAndLosing: {
          title: "流水 & 亏损",
          convertButton: "转换为持有金额",
          rollingPercentage: {
            slot: "流水 % (老虎机)",
            casino: "流水 % (真人)",
            sports: "流水 % (体育)",
          },
          losingPercentage: {
            slot: "亏损 % (老虎机)",
            casino: "亏损 % (真人)",
            sports: "亏损 % (体育)",
          },
        },
        bettingAndRolling: {
          title: "投注 & 流水",
          bettingWinning: {
            title: "投注/中奖",
            slot: "投注/中奖 (老虎机)",
            casino: "投注/中奖 (真人)",
            sports: "投注/中奖 (体育)",
          },
          rolling: {
            slot: "流水 (老虎机)",
            casino: "流水 (真人)",
            sports: "流水 (体育)",
          },
        },
        moneyMovement: {
          title: "资金移动",
          totalDeposit: "充值总计",
          totalWithdraw: "提现总计",
          totalChipGive: "彩金发放总计",
          totalChipCollect: "彩金回收总计",
        },
      },
    },
    chipTransfer: {
      title: "合作伙伴 彩金转移",
      desc: "管理合作伙伴之间的彩金转移",
      columns: {
        fromUser: "发送者",
        fromRole: "发送者类型",
        toUser: "接收者",
        toRole: "接收者类型",
        amount: "数量",
        memo: "备注",
        createdAt: "转移时间",
      },
    },
    partnerUserChipTransfer: {
      title: "合作伙伴 ↔ 用户 彩金转移",
      desc: "管理合作伙伴和用户之间的彩金转移",
      search: {
        placeholder: "输入合作伙伴或用户名",
      },
      columns: {
        partnerUsername: "合作伙伴名",
        partnerRole: "合作伙伴类型",
        username: "用户名",
        giveAmount: "发放金额",
        collectAmount: "回收金额",
        createdAt: "时间",
      },
    },
  },
  banking: {
    rechargeHistory: {
      title: "充值历史",
      desc: "充值历史页面",
      columns: {
        id: "#",
        type: "类型",
        amount: "充值金额",
        countAndTotal: "充值笔数 / 总计",
        balanceChange: "充值前 / 充值后",
        username: "用户名",
        affiliation: "所属",
        bankName: "银行名称",
        accountHolder: "账户持有人",
        dates: "申请时间 / 处理时间",
        status: "状态",
        details: "详情",
        memo: "备注",
        deposit: "充值",
        withdraw: "提现",
      },
    },
    exchangeHistory: {
      title: "兑换历史",
      desc: "兑换历史页面",
      columns: {
        id: "#",
        type: "类型",
        amount: "兑换金额",
        countAndTotal: "兑换笔数 / 总计",
        balanceChange: "兑换前 / 兑换后",
        username: "用户名",
        affiliation: "所属",
        bankName: "银行名称",
        accountHolder: "账户持有人",
        dates: "申请时间 / 处理时间",
        status: "状态",
        details: "详情",
        memo: "备注",
        deposit: "充值",
        withdraw: "提现",
      },
    },
  },
  notices: {
    list: {
      title: "公告管理",
      desc: "公告管理页面",
      createButton: "发布公告",
      columns: {
        title: "标题",
        status: "状态",
        viewCount: "浏览量",
        createdAt: "创建时间",
        updatedAt: "更新时间",
        actions: "管理",
        pinButton: "置顶",
        unpinButton: "取消置顶",
        viewButton: "查看",
        editButton: "编辑",
        deleteButton: "删除",
      },
    },
    detail: {
      title: "公告详情",
      desc: "公告详情页面",
      notFound: "公告未找到",
    },
    edit: {
      title: "编辑公告",
      desc: "编辑公告页面",
      titleLabel: "标题",
      contentLabel: "内容",
      statusLabel: "状态",
      pinnedLabel: "置顶显示",
    },
    delete: {
      title: "删除公告",
      desc: "确定要删除这条公告吗？",
    },
    status: {
      all: "全部",
      draft: "草稿",
      published: "已发布",
      deleted: "已删除",
    },
  },
  inquiry: {
    types: {
      deposit: "充值咨询",
      withdrawal: "提现咨询",
      account: "开户咨询",
      other: "其他咨询",
    },
  },
  inquiries: {
    list: {
      title: "1:1 咨询",
      desc: "1:1 咨询列表页面",
      columns: {
        title: "标题",
        status: "状态",
        creator: "创建者",
        createdAt: "创建日期",
        answerer: "回复者",
        answeredAt: "回复日期",
      },
      search: {
        placeholder: "搜索标题或内容",
      },
      noData: "暂无咨询记录。",
    },
    detail: {
      title: "咨询详情",
      desc: "咨询详情页面",
      notFound: "未找到咨询。",
    },
    status: {
      all: "全部",
      pending: "待处理",
      inProgress: "处理中",
      completed: "已完成",
      deleted: "已删除",
    },
    answer: {
      title: "回复",
      status: "处理状态",
      content: "回复内容",
      placeholder: "请输入回复内容",
      submit: "提交回复",
      success: "回复已提交。",
      error: "回复提交失败。",
      required: "请输入回复内容。",
    },
  },
  bettingStatus: {
    common: {
      rollingDesc: "※ 滚动 = 投注 x 滚动%, ※ 实际 = 滚动 - 下线滚动",
      losingDesc: "※ 亏损 = (投注 - 中奖 - 总滚动) x 滚动%, ※ 实际 = 亏损 - 下线亏损",
      selectedPartner: "选择合作伙伴的投注 & 滚动数据",
      downlinePartners: "下线合作伙伴的投注 & 滚动数据",
    },
    slot: {
      title: "投注状态(老虎机)",
      desc: "老虎机投注状态页面",
    },
    casino: {
      title: "投注状态(赌场)",
      desc: "赌场投注状态页面",
    },
    sports: {
      title: "投注状态(体育)",
      desc: "体育投注状态页面",
    },
    slotHistory: {
      title: "投注历史(老虎机)",
      desc: "老虎机投注历史页面",
    },
    casinoHistory: {
      title: "投注历史(赌场)",
      desc: "赌场投注历史页面",
    },
    sportsHistory: {
      title: "投注历史(体育)",
      desc: "体育投注历史页面",
    },
    losingSettlement: {
      slot: {
        title: "亏损清算(老虎机)",
        desc: "老虎机亏损清算页面",
      },
      casino: {
        title: "亏损清算(赌场)",
        desc: "赌场亏损清算页面",
      },
      sports: {
        title: "亏损清算(体育)",
        desc: "体育亏损清算页面",
      },
      columns: {
        role: "区分",
        partnerName: "合作伙伴名称",
        totalPartnerDeposit: "合作伙伴总充值",
        totalPartnerWithdraw: "合作伙伴总提现",
        totalBetting: "总投注金额",
        totalWinning: "Total Winning",
        bettingResult: "Total Betting - Total Winning",
        rollingPercentage: "Rolling %",
        totalRolling: "Total Rolling",
        actualRolling: "Actual Rolling",
        losingPercentage: "Losing %",
        losingAmount: "Losing Amount",
        settlementAmount: "Settlement Amount",
        downlineSettlementAmount: "Downline Settlement Amount",
        actualPaymentAmount: "Actual Payment Amount",
      },
    },
    lossAdjustment: {
      title: "损失金额调整",
      desc: "损失金额调整页面",
      columns: {
        headquarter: "总部",
        branch: "分部",
        storeUsername: "店铺用户名",
        yesterdayBetting: "昨日 投注",
        yesterdayWin: "昨日 中奖",
        yesterdayRolling: "昨日 流水",
        subtract: "减",
        loss: "损失",
        add: "加",
      },
      buttons: {
        setAll0: "全部设为0",
        setAll5: "全部设为5",
        setAll10: "全部设为10",
        setAll15: "全部设为15",
        setAll20: "全部设为20",
      },
    },
    lossRecovery: {
      title: "损失金额恢复",
      desc: "损失金额恢复页面",
      columns: {
        storeName: "店铺名称",
        username: "用户名",
        gameName: "游戏名称",
        date: "日期",
        bettingAmount: "投注金额",
        winningAmount: "中奖金额",
        rollingAmount: "流水金额",
        storeRecoveryStatus: "店铺恢复状态",
        userRecoveryStatus: "用户恢复状态",
        status: "状态",
      },
    },
    bettingStatusColumns: {
      role: "区分",
      partnerName: "合作伙伴名称",
      totalPartnerDeposit: "合作伙伴总充值",
      totalPartnerWithdraw: "合作伙伴总提现",
      totalBetting: "总投注金额",
      totalWinning: "总中奖金额",
      bettingResult: "投注 - 中奖",
      rollingPercentage: "流水%",
      totalRolling: "总流水金额",
      actualRolling: "实际支付流水",
      bettingProfit: "投注损益",
      currentChip: "持有彩金",
      currentRolling: "持有流水",
    },
  },
  swagger: {
    title: "API 文档",
    description: "Piggy Vault Admin API 文档。",
  },
  settings: {
    title: "设置",
    description: "管理系统设置",
    tabs: {
      general: "通用",
      currency: "货币",
      exchange: "汇率",
      game: "游戏",
      etc: "其他",
    },
    groups: {
      general: {
        title: "通用设置",
        description: "配置通用系统设置。",
      },
      currency: {
        title: "货币设置",
        description: "管理货币显示和标准设置。",
      },
      exchange: {
        title: "汇率设置",
        description: "管理USDT汇率相关设置。",
      },
      game: {
        title: "游戏设置",
        description: "配置游戏相关设置，包括供应商。",
      },
      etc: {
        title: "其他设置",
        description: "管理其他杂项设置。",
      },
    },
    fields: {
      site_name: {
        label: "网站名称",
        description: "网站名称。",
      },
      maintenance: {
        label: "维护模式",
        description: "启用或禁用网站维护模式。(on/off)",
      },
      std_currency: {
        label: "标准货币",
        description: "用于计算的标准货币。",
      },
      dsp_currency: {
        label: "显示货币",
        description: "显示给用户的货币。",
      },
      usdt_exchange_rate: {
        label: "USDT汇率设置",
        description: "USDT汇率JSON数据编辑器。",
      },
      std_game_vendor_id: {
        label: "标准游戏供应商",
        description: "默认游戏供应商ID。",
      },
      // 다른 필드들에 대한 번역도 여기에 추가할 수 있습니다.
    },
    messages: {
      settingKeyNotFound: "找不到设置键 '$key' 的索引",
      loadingSettings: "加载设置...",
      errorLoadingSettings: "加载设置失败",
    },
    save_success: "设置已保存成功！",
  },
  usdtExchangeRateEditor: {
    rawJsonEditorTitle: "原始JSON编辑器",
    exchangeRateAndWalletSettingsTitle: "汇率和钱包设置",
    usdtExchangeRateLabel: "USDT汇率 (ex_rate)",
    myWalletUrlLabel: "我的钱包URL (my_wallet)",
    quickAmountsSettingsTitle: "快速金额设置:",
    quickAmounts: {
      hide: "(隐藏)",
      show: "(显示)", 
      amountPlaceholder: "金额",
      labelPlaceholder: "标签 (例如: ¥10)",
      addAmountButton: "添加快速金额",
    },
    addLanguagePrompt: "输入要添加的语言代码 (例如: th):",
    languageExistsError: "语言设置已存在。",
    addNewLanguageQuickAmountButton: "添加新语言快速金额",
    wallets: {
      title: "提现钱包列表 (wallets)",
      walletNumberLabel: "钱包",
      namePlaceholder: "钱包名称 (例如: Polygon Tether)",
      addressPlaceholder: "钱包地址",
      qrPlaceholder: "二维码图片路径 (例如: /uploads/polygon-img.jpeg)",
      deleteWalletButton: "删除此钱包",
      addWalletButton: "添加提现钱包",
    },
    errors: {
      invalidJsonParse: "无效的JSON格式",
      failedStringifyJson: "转换JSON字符串失败 (onChange)",
      invalidJsonFormatOrUseUI:
        "无效的JSON格式。请直接编辑或使用下方的界面。",
    },
    rawJsonEditor: {
      editJsonDirectlyLabel: "直接编辑JSON",
      warningMessage:
        "警告：如果JSON格式不正确，设置可能无法正确保存。",
    },
    loadingEditor: "加载编辑器中...",
  },
};

export default data;
